var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.671,
    height: 11.753,
    viewBox: "0 0 15.671 11.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_445",
    "data-name": "Trazado 445",
    d: "M7.836,3a6.912,6.912,0,0,1,3.366.9,9.906,9.906,0,0,1,2.416,1.921A12.973,12.973,0,0,1,15.6,8.585a.653.653,0,0,1,0,.584,12.973,12.973,0,0,1-1.985,2.766A9.906,9.906,0,0,1,11.2,13.856a6.912,6.912,0,0,1-3.366.9,6.912,6.912,0,0,1-3.366-.9,9.906,9.906,0,0,1-2.416-1.921A12.973,12.973,0,0,1,.069,9.169a.653.653,0,0,1,0-.584A12.973,12.973,0,0,1,2.054,5.818,9.906,9.906,0,0,1,4.47,3.9,6.912,6.912,0,0,1,7.836,3Zm6.437,5.877a12.25,12.25,0,0,0-1.631-2.19,8.57,8.57,0,0,0-2.087-1.655,5.617,5.617,0,0,0-2.719-.726c-3.523,0-5.828,3.52-6.437,4.571a12.25,12.25,0,0,0,1.631,2.19,8.57,8.57,0,0,0,2.087,1.655,5.617,5.617,0,0,0,2.719.726C11.358,13.447,13.664,9.927,14.273,8.877Z",
    transform: "translate(0 0)",
    fill: "#6429CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Elipse_554",
    "data-name": "Elipse 554",
    d: "M1.612-1A2.612,2.612,0,1,1-1,1.612,2.615,2.615,0,0,1,1.612-1Zm0,3.918A1.306,1.306,0,1,0,.306,1.612,1.307,1.307,0,0,0,1.612,2.918Z",
    transform: "translate(6.224 7.265)",
    fill: "#6429CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/showPasswordIcon.86b14ca3cff6c144d658a1739e5e7fc1.svg";
export { ForwardRef as ReactComponent };